module.exports = __webpack_public_path__ + "img/clavier.2cbcbf67.jpg";